var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9984 0C24.1484 0 20.9984 3.15 20.9984 7C20.9984 10.85 24.1484 14 27.9984 14C31.8484 14 34.9984 10.85 34.9984 7C34.9984 3.15 31.8484 0 27.9984 0ZM27.9984 1.4C31.0784 1.4 33.5984 3.92 33.5984 7C33.5984 10.08 31.0784 12.6 27.9984 12.6C24.9184 12.6 22.3984 10.08 22.3984 7C22.3984 3.92 24.9184 1.4 27.9984 1.4ZM27.2984 2.8V6.65L24.7787 8.53945L25.6182 9.66055L28.6984 7.35V2.8H27.2984ZM2.79844 3.5C2.02634 3.5 1.39844 4.1279 1.39844 4.9V25.2C1.39844 25.9721 2.02634 26.6 2.79844 26.6H13.2984V28.7H11.1984C10.0406 28.7 9.09844 29.6422 9.09844 30.8V32.2H25.8984V30.8C25.8984 29.6422 24.9562 28.7 23.7984 28.7H21.6984V26.6H32.1984C32.9705 26.6 33.5984 25.9721 33.5984 25.2V13.248C33.1686 13.6337 32.701 13.9754 32.1984 14.2666L32.1998 25.2H21.6984H13.2984H2.79844V22.4H32.1984V21H2.79844V4.9H19.8732C19.9985 4.4149 20.1644 3.9473 20.3695 3.5H2.79844ZM28.6984 23.1V24.5H30.0984V23.1H28.6984ZM14.6984 26.6H20.2984V28.7H14.6984V26.6ZM11.1984 30.1H13.2984H21.6984H23.7984C24.1841 30.1 24.4984 30.4143 24.4984 30.8H10.4984C10.4984 30.4143 10.8127 30.1 11.1984 30.1Z",
    fill: "#FFC542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchStatus);
export default __webpack_public_path__ + "static/media/BatchStatus.366bcb024ac8618a4df65924077e3afe.svg";
export { ForwardRef as ReactComponent };